import React, { useState } from 'react';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <style>
        {`
        
.pq-section.pq-style-1.text-center {
  text-align: center;
  margin-bottom: 20px;
}

.pq-section-sub-title {
  font-size: 18px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.pq-section-title {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}


.pq-accordion-block {
  width: 100%;
}

.pq-accordion-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pq-accordion-box.active {
  border-color: #239857;
}

.pq-ad-title {
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-title-text {
  font-size: 16px;
  color: #333;
  margin: 0;
  flex: 1;
}

.pq-accordion-details {
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.pq-accordion-details.open {
  padding: 15px;
  max-height: 500px; 
}

.pq-detail-text {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.fa {
  font-size: 14px;
  color: #239857;
  transition: transform 0.3s ease;
}

.fa-chevron-down {
  transform: rotate(0deg);
}

.fa-chevron-up {
  transform: rotate(180deg);
}
.pq-accordion-block .pq-accordion-box .pq-accordion-details {
  padding: 0 20px  !important;
  border: 1px solid var(--grey-color);
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
`}
      </style>
      <section className="faq">
        <div className="container py-4">
          <div className="row">
				
              <div className="col-md-7">
					
					<div className="pq-section pq-style-1 text-center">
					  <h2 className="pq-section-title">Frequently Asked Questions (FAQ’s)</h2>
					</div>
					
					<div className="col-xl-12 mt-xl-0 ps-xl-3">
					  <div className="pq-accordion-block mt-4">
						{[ 
						  { question: "What causes frequent Nosebleeds (Epistaxis)?", answer: "Frequent nosebleeds can be caused by dry air, nose picking, allergies, infections, sinus issues, or high blood pressure. In some cases, underlying conditions like nasal polyps or blood vessel abnormalities can also lead to Epistaxis. An ENT specialist can identify the exact cause through proper examination." },
						  { question: "When should I see a doctor for Nosebleeds?", answer: "If your nosebleed lasts more than 15–20 minutes, happens often, or is accompanied by dizziness or weakness, you should see an ENT doctor immediately. Persistent or severe bleeding could indicate a deeper nasal or sinus problem that may need medical or surgical treatment." },
						  { question: "How is Epistaxis treated?", answer: "Treatment depends on the cause and severity. Mild Nosebleeds are usually managed with nasal ointments, humidifiers, and lifestyle changes. For more serious cases, ENT doctors may perform nasal cauterization or minimally invasive Epistaxis surgery to seal the bleeding vessels and prevent recurrence." },
						  {question: "What is Epistaxis Surgery, and is it safe?", answer: "Epistaxis surgery is a simple and safe procedure performed by an ENT specialist to control frequent or severe nosebleeds. It involves identifying and sealing the bleeding vessels using advanced techniques, ensuring long-term relief and minimal discomfort during recovery."},
						  {question: "Can Nosebleeds be prevented in the future?", answer: "Yes, many nosebleeds can be prevented. Keep your nasal passages moist with saline sprays, avoid picking or blowing your nose forcefully, stay hydrated, and use a humidifier during dry weather. Regular ENT check-ups help detect and treat any underlying causes early."}
						].map((item, index) => (
						  <div className={`pq-accordion-box ${activeIndex === index ? 'active' : ''}`} key={index}>
							<div className="pq-ad-title" onClick={() => toggleAccordion(index)}>
							  <h4 className="ad-title-text">
								{item.question}
								<i className={`fa ${activeIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
							  </h4>
							</div>
							<div className={`pq-accordion-details ${activeIndex === index ? 'open' : ''}`}>
							  <p className="pq-detail-text">{item.answer}</p>
							</div>
						  </div>
						))}
					  </div>
					</div>
				</div>
				<div className="col-md-5 m-auto">
                  <div className="card shadow-lg">
                      <iframe width="100%" height="300px" src="https://www.youtube.com/embed/v2jAzMVGF1I" title="Tonsillectomy" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen ></iframe>
                      <div class="p-3"><h5 class="text-success mb-0">Epistaxis (Nose Bleeding) नाक से खून आना के लक्षण, कारण और इलाज | | Dr. Major Rajesh Bhardwaj</h5></div>
				  </div>
              </div>
          </div>
        </div>
      </section>
    </div>
  );
}
